import styled from 'styled-components'
import { makePublicUrl } from 'app/utils/publicUrl'
import { Font14 } from 'components/Typography'

export const CheckboxLabel = styled.label<{ hasLabelText: boolean }>`
  position: relative;

  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }

  input[type='checkbox'] + span {
    ${Font14};
    cursor: pointer;
    border-radius: 4px;
  }

  input[type='checkbox'] + span:before {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    vertical-align: -6px;
    margin-right: ${(p) => (p.hasLabelText ? '16px' : 0)};
    background: transparent;
    background-image: url(${makePublicUrl(
      'images/customCheckbox/checkbox-inactive.svg'
    )});
    background-repeat: no-repeat;
    background-position: center;
  }

  input[type='checkbox']:checked + span:before {
    background-image: url(${makePublicUrl(
      'images/customCheckbox/checkbox-active.svg'
    )});
    background-repeat: no-repeat;
    background-position: center;
  }

  input[type='checkbox']:disabled + span:before {
    cursor: default;
    background-image: url(${makePublicUrl(
      'images/customCheckbox/checkbox-inactive-disabled.svg'
    )});
    background-repeat: no-repeat;
    background-position: center;
  }

  input[type='checkbox']:checked:disabled + span:before {
    cursor: default;
    background-image: url(${makePublicUrl(
      'images/customCheckbox/checkbox-active-disabled.svg'
    )});
    background-repeat: no-repeat;
    background-position: center;
  }
`
